import React from "react";
import { 
  TableRow, 
  TableCell,   
  Button, 
} from "@mui/material";
import CustomCheckbox from "./CustomCheckbox";   

const cellStyle = {
  padding: '10px 16px',
}; 

const PayRateRow = ({ row, isSelected, onSelectToggle, }) => {
  return (
    <TableRow sx={{
      '&:hover': { boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' },
      backgroundColor: '#fff',
      borderRadius: '10px',
      transition: 'box-shadow 0.3s ease',
    }}>
      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        minWidth: '32px', 
        maxWidth: '32px',
        borderRadius: '10px 0 0 10px',
      }}>
        <CustomCheckbox checked={isSelected} onChange={onSelectToggle} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        {row.id}
      </TableCell>

    
 
 <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <Button
      sx={{
        background: '#C7E4D2', // light green
        color: '#179046',  
        border:'1px solid #179046',                                                                                                                       
        fontSize: '13px',                                                                 
        textTransform: 'capitalize',
        borderRadius: '50px',
        px: 3,
      }}
    > {row.status}</Button>
      </TableCell>
  



 <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.payPeriod}
      </TableCell>
 <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.rate}
      </TableCell>
 <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.type}
      </TableCell>
 <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.startDate}
      </TableCell>
     
    </TableRow>
  );
};

export default PayRateRow;
